import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Trophy, ChevronLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import AchievementsTab from '../components/AchievementsTab';
import { AppBackButton } from '../components/AppBackButton';
import { AnimatedIcon } from '../components/AnimatedIcon';
import { StudyPageHeader } from '../components/StudyPageHeader';

const AchievementsPage: React.FC = () => {
    const { t } = useTranslation();
    const { user } = useAuth();
    const navigate = useNavigate();

    if (!user) return null;

    return (
        <div className="max-w-3xl mx-auto space-y-8 animate-in fade-in slide-in-from-bottom-4 duration-500">
            <AppBackButton fallbackTo="/personal-hub" />

            <StudyPageHeader tourKey="achievements" title={t('achievements.title', 'Conquistas')} />

            {!user.isGuest ? (
                <div data-tour="achievements-list"><AchievementsTab userId={user.id} /></div>
            ) : (
                <div data-tour="achievements-list" className="bg-surface rounded-[32px] px-8 py-14 sm:p-14 border border-black/[0.06] dark:border-white/[0.06] text-center space-y-4">
                    <div className="w-20 h-20 mx-auto rounded-full bg-tint-butter text-ink flex items-center justify-center"><AnimatedIcon motion="bounce" active><Trophy size={30} strokeWidth={1.5} /></AnimatedIcon></div>
                    <h2 className="font-display text-2xl font-light tracking-[-0.04em] text-ink">{t('achievements.restrictedArea', 'Área Restrita')}</h2>
                    <p className="text-muted text-sm max-w-sm mx-auto leading-relaxed">{t('achievements.guestAchievementsDesc', 'Faça login para começar a colecionar suas conquistas e acompanhar seu progresso!')}</p>
                    <button
                        onClick={() => navigate('/login')}
                        className="h-12 px-7 bg-primary text-slate-900 rounded-full text-sm font-medium hover:opacity-90 active:scale-95 transition-all"
                    >
                        {t('achievements.connectAccount', 'Conectar Conta')}
                    </button>
                </div>
            )}
        </div>
    );
};

export default AchievementsPage;
